import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.w6v_1 = partyId;
        this.x6v_1 = name;
        this.y6v_1 = email;
        this.z6v_1 = pairingRule;
        this.a6w_1 = badgesEnabled;
        this.b6w_1 = defaultBadgeName;
        this.c6w_1 = alternateBadgeName;
        this.d6w_1 = callSignsEnabled;
        this.e6w_1 = animationsEnabled;
        this.f6w_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.w6v_1.toString() + ', name=' + toString(this.x6v_1) + ', email=' + toString(this.y6v_1) + ', pairingRule=' + toString(this.z6v_1) + ', badgesEnabled=' + toString(this.a6w_1) + ', defaultBadgeName=' + toString(this.b6w_1) + ', alternateBadgeName=' + toString(this.c6w_1) + ', callSignsEnabled=' + toString(this.d6w_1) + ', animationsEnabled=' + toString(this.e6w_1) + ', animationSpeed=' + toString(this.f6w_1) + ')';
      }
      hashCode() {
        var result = this.w6v_1.hashCode();
        result = imul(result, 31) + hashCode(this.x6v_1) | 0;
        result = imul(result, 31) + hashCode(this.y6v_1) | 0;
        result = imul(result, 31) + hashCode(this.z6v_1) | 0;
        result = imul(result, 31) + hashCode(this.a6w_1) | 0;
        result = imul(result, 31) + hashCode(this.b6w_1) | 0;
        result = imul(result, 31) + hashCode(this.c6w_1) | 0;
        result = imul(result, 31) + hashCode(this.d6w_1) | 0;
        result = imul(result, 31) + hashCode(this.e6w_1) | 0;
        result = imul(result, 31) + hashCode(this.f6w_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.w6v_1.equals(other.w6v_1))
          return false;
        if (!equals(this.x6v_1, other.x6v_1))
          return false;
        if (!equals(this.y6v_1, other.y6v_1))
          return false;
        if (!equals(this.z6v_1, other.z6v_1))
          return false;
        if (!equals(this.a6w_1, other.a6w_1))
          return false;
        if (!equals(this.b6w_1, other.b6w_1))
          return false;
        if (!equals(this.c6w_1, other.c6w_1))
          return false;
        if (!equals(this.d6w_1, other.d6w_1))
          return false;
        if (!equals(this.e6w_1, other.e6w_1))
          return false;
        if (!equals(this.f6w_1, other.f6w_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
